"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenUserBalance = exports.useOpenEmailConfirm = exports.useOpenEmailVerify = exports.useOpenLogInBonusCongrats = exports.useOpenWheel = exports.useOpenCashBonus = exports.useOpenLevelUp = exports.useOpenDailyDigest = exports.useOpenWithdrawalCheck = exports.useOpenWithdrawalAccepted = exports.useOpenHomePage = exports.useOpenGameSearch = exports.useOpenProfileMenu = exports.useOpenDepositWithPromoCode = exports.useOpenDeposit = exports.useOpenWelcome = exports.useOpenSignUp = exports.useOpenSignIn = exports.useModalLink = exports.useOpenModal = exports.useCloseModal = void 0;
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var config_1 = require("./config");
var useGenerateUrlWithLang_1 = require("./useGenerateUrlWithLang");
var MODAL = 'modal';
var BACK = 'back';
var useCloseModal = function (resetSearchParams) {
    var router = (0, navigation_1.useRouter)();
    var pathname = (0, navigation_1.usePathname)();
    var searchParams = (0, navigation_1.useSearchParams)();
    return (0, react_1.useCallback)(function () {
        var existedSearchParams = searchParams.toString();
        var currentModal = searchParams.get(MODAL);
        var back = searchParams.get(BACK);
        if (back && !resetSearchParams) {
            router.replace(back);
            return;
        }
        if (currentModal && currentModal !== '') {
            existedSearchParams = existedSearchParams
                .replace("".concat(MODAL, "=").concat(currentModal), '')
                .replace(/^&/, '');
        }
        if (resetSearchParams)
            router.replace(pathname);
        else
            router.replace(existedSearchParams ? pathname + '?' + existedSearchParams : pathname);
    }, [resetSearchParams, router, pathname, searchParams]);
};
exports.useCloseModal = useCloseModal;
var useOpenModal = function (slug) {
    var router = (0, navigation_1.useRouter)();
    var pathname = (0, navigation_1.usePathname)();
    var searchParams = (0, navigation_1.useSearchParams)();
    return (0, react_1.useCallback)(function (name, params) {
        var existedSearchParams = searchParams.toString();
        var currentModal = searchParams.get(MODAL);
        if (currentModal && currentModal !== '') {
            existedSearchParams = existedSearchParams
                .replace("".concat(MODAL, "=").concat(currentModal), '')
                .replace(/^&/, '');
        }
        if (typeof params === 'string') {
            existedSearchParams = params;
        }
        router.replace(pathname +
            "?".concat(MODAL, "=").concat(slug || name) +
            (existedSearchParams === '' ? '' : "&".concat(existedSearchParams)));
    }, [router, pathname, searchParams, slug]);
};
exports.useOpenModal = useOpenModal;
var useModalLink = function (slug, isSaveParams) {
    var pathname = (0, navigation_1.usePathname)();
    var searchParams = (0, navigation_1.useSearchParams)();
    return (0, react_1.useMemo)(function () {
        var existedSearchParams = searchParams.toString();
        var currentModal = searchParams.get(MODAL);
        var back = searchParams.get(BACK);
        if (back && !isSaveParams) {
            return back;
        }
        if (currentModal && currentModal !== '') {
            existedSearchParams = existedSearchParams
                .replace("".concat(MODAL, "=").concat(currentModal), '')
                .replace(/^&/, '');
        }
        return (pathname +
            "?".concat(MODAL, "=").concat(slug) +
            (existedSearchParams === '' ? '' : "&".concat(existedSearchParams)));
    }, [pathname, searchParams, slug, isSaveParams]);
};
exports.useModalLink = useModalLink;
var useOpenSignIn = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.SIGN_IN_MODAL);
    return (0, react_1.useCallback)(function (params) {
        openModal(undefined, params);
    }, [openModal]);
};
exports.useOpenSignIn = useOpenSignIn;
var useOpenSignUp = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.SIGN_UP_MODAL);
    return (0, react_1.useCallback)(function () {
        openModal();
    }, [openModal]);
};
exports.useOpenSignUp = useOpenSignUp;
var useOpenWelcome = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.WELCOME);
    return (0, react_1.useCallback)(function () {
        openModal();
    }, [openModal]);
};
exports.useOpenWelcome = useOpenWelcome;
var useOpenDeposit = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.DEPOSIT);
    return (0, react_1.useCallback)(function (params) {
        openModal(undefined, params);
    }, [openModal]);
};
exports.useOpenDeposit = useOpenDeposit;
var useOpenDepositWithPromoCode = function (promocode) {
    var openDeposit = (0, exports.useOpenDeposit)();
    return (0, react_1.useCallback)(function () {
        if (!promocode)
            return openDeposit();
        openDeposit("promocode=".concat(promocode));
    }, [openDeposit, promocode]);
};
exports.useOpenDepositWithPromoCode = useOpenDepositWithPromoCode;
var useOpenProfileMenu = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.PROFILE_MENU);
    return (0, react_1.useCallback)(function () {
        openModal();
    }, [openModal]);
};
exports.useOpenProfileMenu = useOpenProfileMenu;
var useOpenGameSearch = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.GAME_SEARCH);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenGameSearch = useOpenGameSearch;
var useOpenHomePage = function () {
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, useGenerateUrlWithLang_1.useGenerateUrlWithLang)();
    return (0, react_1.useCallback)(function () {
        router.replace(generateUrlWithLang('/'));
    }, [router, generateUrlWithLang]);
};
exports.useOpenHomePage = useOpenHomePage;
var useOpenWithdrawalAccepted = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.WITHDRAWAL_ACCEPTED);
    return (0, react_1.useCallback)(function () {
        openModal();
    }, [openModal]);
};
exports.useOpenWithdrawalAccepted = useOpenWithdrawalAccepted;
var useOpenWithdrawalCheck = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.WITHDRAWAL_CHECK);
    return (0, react_1.useCallback)(function () {
        openModal();
    }, [openModal]);
};
exports.useOpenWithdrawalCheck = useOpenWithdrawalCheck;
var useOpenDailyDigest = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.DAILY_DIGEST);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenDailyDigest = useOpenDailyDigest;
var useOpenLevelUp = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.LEVEL_UP);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenLevelUp = useOpenLevelUp;
var useOpenCashBonus = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.CASH_BONUS);
    return (0, react_1.useCallback)(function (params) {
        openModal(undefined, params);
    }, [openModal]);
};
exports.useOpenCashBonus = useOpenCashBonus;
var useOpenWheel = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.WHEEL);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenWheel = useOpenWheel;
var useOpenLogInBonusCongrats = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.SIGN_IN_BONUS_CONGRATS_MODAL);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenLogInBonusCongrats = useOpenLogInBonusCongrats;
var useOpenEmailVerify = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.EMAIL_VERIFY);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenEmailVerify = useOpenEmailVerify;
var useOpenEmailConfirm = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.EMAIL_CONFIRM);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenEmailConfirm = useOpenEmailConfirm;
var useOpenUserBalance = function () {
    var openModal = (0, exports.useOpenModal)(config_1.POPUP_CONSTANTS.USER_BAlANCE);
    return (0, react_1.useCallback)(function (e) {
        openModal();
    }, [openModal]);
};
exports.useOpenUserBalance = useOpenUserBalance;
